import React from 'react';

import VerifyDrawer from 'containers/pages/Email/VerifyDrawer';
import AddressEntry from 'containers/pages/Email/AddressEntry';

const VerifyNewDomain = ({ open, handleSuccess, toggleDrawer }) => {
  return (
    <VerifyDrawer {...{ open, toggleDrawer }}>
      <AddressEntry {...{ handleSuccess }} />
    </VerifyDrawer>
  );
};

export default VerifyNewDomain;
